import { format, isEmpty } from "@swiggy-private/js-utils";
import { IDimensionType, IRelativeDimensionReference } from "@swiggy-private/dls-react-mxn/dist/WidgetController/type";
import { WidgetTypes } from "@swiggy-private/dls-react-mxn/dist/WidgetController/constants";
import {
    DINE_CASH_AMOUNT_FORMAT,
    DINE_CASH_SUBCOPY_FORMAT,
    DINE_CASH_SUBCOPY_MAX_REACHED_FORMAT,
    LOTTIE_DYNAMIC_KEYS,
    ScreenImpressionState,
} from "./constants";

export const isMaxPoolAmountReached = (totalAmountReceived?: number, maxPoolAmountAllowed?: number): boolean => {
    if (isEmpty(totalAmountReceived) || isEmpty(maxPoolAmountAllowed)) {
        return false;
    }
    return (totalAmountReceived ?? 0) >= (maxPoolAmountAllowed ?? 0);
};

export const getLottieInfoProp = ({
    url,
    totalAmountReceived,
    maxPoolAmountAllowed,
    maxAmountReached,
}: {
    url: string;
    totalAmountReceived?: number;
    maxPoolAmountAllowed?: number;
    maxAmountReached?: boolean;
}) => {
    const subcopyValue = maxAmountReached
        ? DINE_CASH_SUBCOPY_MAX_REACHED_FORMAT
        : format(DINE_CASH_SUBCOPY_FORMAT, maxPoolAmountAllowed);
    return {
        position: 0,
        isLastCard: true,
        info: [
            {
                id: "1",
                lotteUrl: url,
                dynamicInfoV2: [
                    {
                        key: LOTTIE_DYNAMIC_KEYS.AMOUNT,
                        dynamicValue: {
                            value: format(DINE_CASH_AMOUNT_FORMAT, totalAmountReceived),
                        },
                    },
                    {
                        key: LOTTIE_DYNAMIC_KEYS.SUBCOPY,
                        dynamicValue: {
                            value: subcopyValue,
                        },
                    },
                ],
            },
        ],
        style: {
            width: {
                type: IDimensionType.TYPE_RELATIVE,
                value: 1,
                reference: IRelativeDimensionReference.RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH,
            },
        },
        "@type": WidgetTypes.LOTTIE_INFO_LAYOUT_CARD as WidgetTypes.LOTTIE_INFO_LAYOUT_CARD,
    };
};

export const formatText = (text: string, maxPerPersonCap?: number, maxPoolAmountAllowed?: number) => {
    return text
        .split("{maxPerPersonCap}")
        .join(maxPerPersonCap?.toString() || "")
        .split("{maxPoolAmountAllowed}")
        .join(maxPoolAmountAllowed?.toString() || "");
};

export const generateQRCodeImageUrl = (base64Image: string) => {
    return `data:image/png;base64,${base64Image}`;
};

export const getScreenImpressionState = (
    maxAmountReached: boolean,
    totalAmountReceived?: number,
): ScreenImpressionState => {
    if (maxAmountReached) return ScreenImpressionState.LIMIT_REACHED;
    if (totalAmountReceived) return ScreenImpressionState.RECEIVED;
    return ScreenImpressionState.DEFAULT;
};
